export const API_URL = import.meta.env.VITE_API_URL;

export const DEFAULT_ZOOM = 13;
export const ZOOM_SNAP = 0.1;
export const NEAREST_PHOTOS_COUNT = 3;

export const PHOTO_TYPE_EMOJIS = ['☁️', '🌌', '🏙️', '🌅', '🌇'];

export const POSITION_CLASSES = {
  bottomleft: 'leaflet-bottom leaflet-left',
  bottomright: 'leaflet-bottom leaflet-right',
  topleft: 'leaflet-top leaflet-left',
  topright: 'leaflet-top leaflet-right',
}
